import lodashGet from 'lodash/get';
import { util } from '@/api/util';
import { getContactLabel } from './common';
export const transEnterpriseItemToContact = (item, _lastUpdateTime, options) => {
    var _a;
    const currentCompanyId = (_a = options.currentCompanyId) !== null && _a !== void 0 ? _a : options.contactUtil.getCurrentCompanyId(options._account);
    const obj = {};
    const _email = (item.email || '').toLocaleLowerCase();
    const _displayEmail = (item.displayEmail || '').toLocaleLowerCase();
    obj.displayEmail = _displayEmail || _email;
    obj.contactName = item.qiyeNickName;
    obj.accountName = _email;
    obj.accountId = util.getUnique(_email, item.orgId);
    obj.accountOriginId = item.qiyeAccountId;
    const nickName = item.qiyeNickName || '';
    const pinyinChars = nickName.split('').map((char) => util.toPinyin(char));
    obj.contactPYName = pinyinChars.join('');
    obj.contactPYLabelName = pinyinChars.map(py => py.slice(0, 1).toLocaleLowerCase()).join('');
    obj.enterpriseId = item.orgId;
    obj.accountVisible = item.addrVisible;
    obj.accountStatus = item.status;
    obj.accountType = item.type;
    if (item.unitNamePathList && item.unitNamePathList.length) {
        obj.position = item.unitNamePathList.map(subUnitItem => subUnitItem.filter(unit => unit.showCode === 0).map(unit => unit.unitName)).filter(names => names.length > 0);
    }
    else {
        obj.position = [];
    }
    obj.enableIM = item.enableIM;
    if (currentCompanyId) {
        obj.enableIM = obj.enableIM && obj.enterpriseId === currentCompanyId;
    }
    if (item.iconVO) {
        obj.avatar = item.iconVO.mediumUrl;
        obj.avatarPendant = item.iconVO.pendantUrl;
    }
    obj.visibleCode = item.showCode === undefined ? 0 : item.showCode;
    obj.enterpriseId = obj.enterpriseId || -1;
    obj.id = obj.accountOriginId;
    obj.job = item.job;
    obj.contactLabel = getContactLabel(obj.contactPYName);
    obj.type = 'enterprise';
    obj.updateTime = new Date(_lastUpdateTime);
    obj._lastUpdateTime = _lastUpdateTime;
    return obj;
};
export const transEnterpriseListToContact = (list, _lastUpdateTime = Date.now(), options) => {
    const currentCompanyId = options.contactUtil.getCurrentCompanyId(options._account);
    const contactList = list.map(item => transEnterpriseItemToContact(item, _lastUpdateTime, {
        _account: options._account,
        currentCompanyId,
        contactUtil: options.contactUtil,
    }));
    return contactList;
};
export const transEnterpriseItem2ContactItem = (item, _lastUpdateTime = Date.now(), force = false) => {
    const _email = (item.email || '').toLocaleLowerCase();
    const _displayEmail = (item.displayEmail || '').toLocaleLowerCase();
    let itemList = [];
    const yunxinType = {
        contactItemVal: item.yunxinAccountId,
        contactItemRefer: item.yunxinToken,
        contactItemType: 'yunxin',
        isDefault: 0,
    };
    const telType = {
        contactItemVal: item.tel,
        contactItemRefer: '',
        contactItemType: 'TEL',
        isDefault: 0,
    };
    const mobileType = {
        contactItemVal: item.mobile,
        contactItemRefer: '',
        contactItemType: 'MOBILE',
        isDefault: 0,
    };
    const allEmails = [...new Set([_displayEmail, _email].filter(item => item && item.trim().length))];
    if (!force || allEmails.length >= 1) {
        allEmails.forEach((emailVal, index) => {
            itemList.push({
                contactItemVal: emailVal,
                contactItemRefer: '',
                contactItemType: 'EMAIL',
                emailType: index === 0 ? -1 : 1,
                isDefault: index === 0 ? 1 : 0,
            });
        });
    }
    if (yunxinType.contactItemVal) {
        itemList.push(yunxinType);
    }
    if (telType.contactItemVal) {
        itemList.push(telType);
    }
    if (mobileType.contactItemVal) {
        itemList.push(mobileType);
    }
    itemList = itemList.map(_item => (Object.assign(Object.assign({}, _item), { contactId: item.qiyeAccountId, type: 'enterprise', enterpriseId: item.orgId, _lastUpdateTime, id: util.getUnique(item.qiyeAccountId, _item.contactItemType, _item.contactItemVal) })));
    return itemList;
};
export const transEnterpriseListToContactItem = (list, _lastUpdateTime = Date.now()) => {
    const contactItemList = list.reduce((total, item) => {
        transEnterpriseItem2ContactItem(item, _lastUpdateTime).forEach(item => {
            total.push(item);
        });
        return total;
    }, []);
    return contactItemList;
};
export const transEnterprise2OrgContact = (item, _lastUpdateTime) => {
    if (!item || !Array.isArray(item.accountRankList) || !item.accountRankList.length) {
        return [];
    }
    return item.accountRankList.reduce((total, current) => {
        const { unitId: orgId, accountRank } = current || {};
        if (orgId) {
            const contactId = item.qiyeAccountId;
            const yunxinId = item.yunxinAccountId;
            const enterpriseId = item.orgId;
            const rankNum = accountRank;
            total.push({
                id: util.getUnique(orgId, contactId),
                orgId,
                contactId,
                yunxinId,
                rankNum,
                enterpriseId,
                type: 'enterprise',
                _lastUpdateTime,
            });
        }
        return total;
    }, []);
};
export const transEnterpriseListToOrgContact = (list, _lastUpdateTime = Date.now()) => {
    const orgContactList = [];
    list.map(item => transEnterprise2OrgContact(item, _lastUpdateTime)).flat();
    return orgContactList;
};
export const transferEnterprise2MutileTableData = (list, lastUpdateTime, options) => {
    const contactList = [];
    const contactItemList = [];
    const orgContactList = [];
    const needDeleteContactIds = [];
    const force = lodashGet(options, 'force', false);
    const unitPathMap = lodashGet(options, 'unitPathMap', new Map());
    const currentCompanyId = options.contactUtil.getCurrentCompanyId(options._account);
    list.forEach(item => {
        if (item.showCode !== 0) {
            needDeleteContactIds.push(item.qiyeAccountId);
            return;
        }
        const singleContact = transEnterpriseItemToContact(item, lastUpdateTime, {
            _account: options._account,
            currentCompanyId,
            contactUtil: options.contactUtil,
        });
        if (!force && unitPathMap.size) {
            singleContact.position = item.unitIdList.filter(unitId => unitPathMap.has(unitId)).map(unitId => unitPathMap.get(unitId).namePathList);
        }
        const singleContactItem = transEnterpriseItem2ContactItem(item, lastUpdateTime, force);
        contactList.push(singleContact);
        contactItemList.splice(Math.max(contactItemList.length - 1, 0), 0, ...singleContactItem);
        if (!force) {
            const singleOrgContact = transEnterprise2OrgContact(item, lastUpdateTime);
            orgContactList.splice(Math.max(contactItemList.length - 1, 0), 0, ...singleOrgContact);
        }
    });
    return {
        contact: contactList,
        contactItem: contactItemList,
        orgContact: orgContactList,
        needDeleteContactIds,
    };
};
